import { Injectable, Injector, inject } from '@angular/core';

import { LoaderFnConfig, LoaderStylesService } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const BetfinderPreloader: LoaderFnConfig = {
    id: 'betfinder-preload',
    loaderFn: (injector: Injector) =>
        injector
            .get(BetfinderLoaderService)
            .load()
            // required to satisfy vanilla constraints for a lazy loaded provider
            .then(() => ({ provide: () => [] })),
    product: ClientConfigProductName.SPORTS,
};

type LazyBetfinderWrapper = Awaited<ReturnType<typeof loadComponent>>;

@Injectable({
    providedIn: 'root',
})
export class BetfinderLoaderService {
    private component: LazyBetfinderWrapper | null = null;

    private readonly stylesLazyLoadingService = inject(LoaderStylesService);

    async load(): Promise<LazyBetfinderWrapper> {
        if (this.component) {
            return this.component;
        }

        const [component] = await Promise.all([loadComponent(), this.loadStylesheet()]);

        this.component = component;

        return component;
    }

    async loadStylesheet(): Promise<void> {
        await this.stylesLazyLoadingService.loadStyles([{ id: 'sports-betfinder', type: 'theme' }]);
    }
}

async function loadComponent() {
    return await import('./betfinder-wrapper.component').then(({ BetfinderWrapperComponent }) => BetfinderWrapperComponent);
}
